export default "__VITE_ASSET__COb9X9Ql__"